var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 512 512"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 176,
    x: 48,
    y: 48,
    stroke: "currentColor",
    strokeWidth: 32,
    rx: 88
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 176,
    x: 288,
    y: 288,
    stroke: "currentColor",
    strokeWidth: 32,
    rx: 88
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 176,
    x: 48,
    y: 288,
    stroke: "currentColor",
    strokeWidth: 32,
    rx: 50
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 176,
    x: 288,
    y: 48,
    stroke: "currentColor",
    strokeWidth: 32,
    rx: 50
  })));
};
export default SvgDashboard;